export default "__VITE_ASSET__B8Gj$8jL__"